<a mat-button class="mat-display-1" url="/login" xNavigateWithRedirect>
  <fa-icon xIconSize="small" icon="user"></fa-icon>
  <ng-container i18n="@@CallToAction.Login">Login</ng-container>
</a>
